module.exports = __webpack_public_path__ + "static/media/Programmer.049668e5.png";